<template>
  <SACModal
    modalClass="admin-action-modal"
    :cardClass="`admin-show-search`"
    :show="showSearch"
    :close="() => closeSearch(false)"
  >
    <template
      v-if="showSearch"
      #content
    >
      <SearchMember />
    </template>
  </SACModal>
</template>

<script>
import SACModal from '@shared/components/sac/SACModal.vue';
import { mapState } from 'vuex';
import SearchMember from '@shared/components/navbar/modal/SearchMember.vue';

export default {
  name: 'ActionModal',
  components: {
    SearchMember,
    SACModal,
  },
  computed: {
    ...mapState({
      showSearch: (state) => state.admin.showSearch,
    }),
  },
  methods: {
    closeSearch() {
      const changes = [{
        field: 'showSearch',
        value: false,
      }];
      this.$store.dispatch('changeAdminValues', changes);
    },
  },
};
</script>

<style lang="scss">
.admin-action-modal {
  .admin-show-search{
    width: 800px;
    height: 75vh;
    max-height: 750px;
  }
}
</style>
